import { JSX } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import {
    videoStreamSelectors,
    videoStreamService,
    videoStreamStore,
    t,
    useMatchedGameId,
    playerSettingsSelectors,
    playerSettingsStore,
    playerSettingsApi,
    analyticsApi,
    tooltipQueueStore,
    TooltipName,
    ClassicGameDefinition,
} from '@bg-shared';
import { SelectListItem } from '../List/SelectListItem';
import { ToggleListItem } from '../List/ToggleListItem';
import { AccordionListItem } from '../List/AccordionListItem';

export const VideoSettings = (): JSX.Element => {
    const gameId = useMatchedGameId();
    const isGuiMode = useStore(playerSettingsStore, playerSettingsSelectors.getGuiMode);
    const qualities = useStore(videoStreamStore, videoStreamSelectors.getQualities);
    const videoStatus = useStore(videoStreamStore, videoStreamSelectors.getStatus(isGuiMode));

    // Todo: remove showgames filter when GUI modes are developed, CRU-429, CRU-438
    return (
        <>
            {!ClassicGameDefinition.isShow(gameId) && (
                <ToggleListItem
                    label={t.string('video')}
                    enabled={!isGuiMode}
                    dataQa="area-toggle-video-list-item"
                    onChange={(newValue) => {
                        tooltipQueueStore.removeIfFirstInQueue(TooltipName.GUI_TIP);
                        playerSettingsApi.update((store) => {
                            store.guiMode = !newValue;
                        });
                        analyticsApi.trackGuiSwitch(!newValue, 'topSettings');
                        analyticsApi.trackVideoSettingSwitch(newValue);
                    }}
                />
            )}
            {!isGuiMode && !!qualities.length && (
                <AccordionListItem
                    dataQa="area-video-qualities-list"
                    label={t.string('video_quality')}
                >
                    {qualities.map(([label, data]) => (
                        <SelectListItem
                            key={label}
                            selected={label === videoStatus}
                            label={label}
                            dataQa={`area-select-quality-${label}`}
                            onClick={() => {
                                videoStreamService.setQuality({
                                    label,
                                    id: data.id as string,
                                    gameId,
                                    placement: 'topSettings',
                                });
                            }}
                        />
                    ))}
                </AccordionListItem>
            )}
        </>
    );
};
